import {HubConnectionBuilder, LogLevel} from '@aspnet/signalr'

export default {
	install(Vue) {
		const connection = new HubConnectionBuilder()
		//	.withUrl('https://192.168.101.123:8090/qbClientHub') //никола локальный деплой
		//  .withUrl('https://localhost:5001/qbClientHub') //никола экспресс
		//	.withUrl('https://localhost:64284/qbClientHub') //никола экспресс
			.withUrl('https://help.qwerty.plus/qbClientHub') //релизный сайт
			.configureLogging(LogLevel.Information)
			.build();

		//Javascript client timeout
		connection.serverTimeoutInMilliseconds = 1000 * 60 * 10;

		// use new Vue instance as an event bus
		const QBHub = new Vue();
		// every component will use this.$QBHub to access the event bus
		Vue.prototype.$QBHub = QBHub;
		// Forward server side SignalR events through $QBHub, where components will listen to them
		connection.on('TicketsNeedUpdate', data => {
			QBHub.$emit('TicketsNeedUpdate', data)
		});

		connection.on('SiteVersionNeedUpdate', data => {
			QBHub.$emit('SiteVersionNeedUpdate', data)
		});

		connection.on('LoginUsersNeedUpdate', data => {
			QBHub.$emit('LoginUsersNeedUpdate', data)
		});

		connection.on('HistoryMessagesNeedUpdate', data => {
			QBHub.$emit('HistoryMessagesNeedUpdate', data)
		});

		connection.on('injectFile', data => {
			QBHub.$emit('injectFile', data)
		});

		connection.on('invalidateUploadSession', data => {
			QBHub.$emit('invalidateUploadSession', data)
		});


		// автоматический реконект
		let startedPromise = null;

		function start() {
			console.log('Start connection to WebSocket');
			startedPromise = connection
				.start()
				.then(() => {
					connection.invoke('GetConnectionId').then((id) => {
						QBHub.connectionId = id
						QBHub.$emit('connectionIdChanged', { connectionId: id });
					})
					QBHub.$emit('showHubConnectionState', {state: 1});
				})
				.catch(err => {
					console.error('Failed to connect with hub', err);
					QBHub.$emit('showHubConnectionState', {state: 0});
					return new Promise((resolve, reject) =>
						setTimeout(() => start().then(resolve).catch(reject), 5000))
				});
			return startedPromise
		}

		connection.onclose(() => {
			QBHub.$emit('showHubConnectionState', {state: 0}); // чтобы ошибка сразу отобразилась на сайте обрабатываем ее в этом методе, т.к. в методе start() при работе сайта через nginx promise резолвится только после срабатывания тайм-аута запроса и следовательно ошибка появится только после истечения этого таймаута, примерно 1 минута.
			start();
		});
		start()

		//без автоматического реконекта
		// connection.start();
	}
}


// WEBPACK FOOTER //
// ./Components/signalR/signalR.js